// Brand-level receipt rendering settings, owned by TouchTab.Receipt (the only service that renders one) and
// reached through PortalAPI. Not part of the Brand model - a brand with nothing stored reads back as the
// defaults below rather than as null, so this is never absent.
export interface ReceiptSettings {
    // Print the multi-payment tally block at the foot of the receipt. Only ever rendered when a check
    // actually took more than one payment, so leaving it on costs a single-payment check nothing.
    showPaymentTally: boolean;
}

export const createReceiptSettings = (): ReceiptSettings => ({ showPaymentTally: false });
